import { WHITELIST_TOKENS_ENDPOINT_BY_CHAIN } from '../configs/api';
import { ChainId_Internal } from '../types';
export const tokenListFetcher = async (chainId) => {
    const endpoint = WHITELIST_TOKENS_ENDPOINT_BY_CHAIN[chainId];
    if (!endpoint)
        throw new Error('Unsupported chainId');
    const list = await (await fetch(endpoint)).json();
    const ans = list
        .filter(({ chain, isSwappable, chainId: _chainId }) => {
        if (_chainId !== chainId)
            return false;
        if (isSwappable === false)
            return false;
        if (chain === 'CRONOSZK')
            return [ChainId_Internal.ZK_EVM, ChainId_Internal.ZK_EVM_TEST].includes(chainId);
        if (chain === 'CRONOS')
            return [
                ChainId_Internal.CRONOS_EVM_MAINNET,
                ChainId_Internal.CRONOS_EVM_TESTNET,
            ].includes(chainId);
        return false;
    })
        .map((t) => ({
        address: t.address,
        symbol: t.symbol,
        decimals: t.decimal,
        iconUrl: t.logoImageSvgUrl,
    }));
    return ans;
};
